var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcPlus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "yu5wzhefba",
    d: "M15.833 10.833L10.833 10.833 10.833 15.833 9.167 15.833 9.167 10.833 4.167 10.833 4.167 9.167 9.167 9.167 9.167 4.167 10.833 4.167 10.833 9.167 15.833 9.167z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-710 -537) translate(705 512) translate(0 20) translate(5 5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ninmh4jk0b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yu5wzhefba"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BEC4CA",
    mask: "url(#ninmh4jk0b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H41.667V41.667H0z",
    transform: "translate(-10.833 -10.833)"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcPlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-plus.25f294c5.svg";
export { ForwardRef as ReactComponent };